// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

export default function BenAdminImpTypeRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['BenAdminImpTypeSelect']

   if (state.product_list['benAdminImp']?.NotInPricebook) {
      return <></>
   }

   if (
      permissions.includes(state.user_role) &&
      state.productBenefitsAdministrationEECount > 0
   ) {
      return (
         <div className='row'>
            <div className='col-bhr1'>
               <div className='form-check form-check-inline'>
                  <input
                     className='form-check-input'
                     type='radio'
                     name='inlineRadioOptions2'
                     id='benAdminImp1Radio'
                     value={state.benAdminImpTypes[0].value}
                     checked={
                        state.benAdminImpType ===
                        state.benAdminImpTypes[0].value
                     }
                     onChange={state.onBenAdminImpOptionChange}
                  ></input>
                  <label className='form-check-label'>
                     {state.benAdminImpTypes[0].name}
                  </label>
               </div>
               <div className='form-check form-check-inline'>
                  <input
                     className='form-check-input'
                     type='radio'
                     name='inlineRadioOptions2'
                     id='benAdminImp2Radio'
                     value={state.benAdminImpTypes[1].value}
                     checked={
                        state.benAdminImpType ===
                        state.benAdminImpTypes[1].value
                     }
                     onChange={state.onBenAdminImpOptionChange}
                  ></input>
                  <label className='form-check-label'>
                     {state.benAdminImpTypes[1].name}
                  </label>
               </div>
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
   }
}
